module.exports = __webpack_public_path__ + "static/github-ce8d9a69bf04e124c31482d09867bef6.svg";